export const SHELL_OVERLAY_Z_INDEX = 999999999;
export const SHELL_OVERLAY_POPUP_Z_INDEX = SHELL_OVERLAY_Z_INDEX + 1;
